import server from 'common/utils/server';
import { getSearchFilter } from 'common/utils/locationUtils';

export function teamMemberReportState(
  state = {
    scorecards: [],
    scorecardsByScorecardId: {},
    teamMemberScoreRows: [],
    totalMembersPages: null,
    totalMembersCount: null,
    teamMemberScoreRowsSortBy: null,
    teamMemberScoreRowsSortDirection: null,
  },
  action
) {
  switch (action.type) {
    case 'qa_reports/RECEIVED_TEAM_MEMBERS_DATA': {
      const {
        scorecards,
        scorecardsByScorecardId,
        teamMemberScoreRows,
        totalMembersPages,
        totalMembersCount,
      } = action;
      return {
        ...state,
        scorecards,
        scorecardsByScorecardId,
        teamMemberScoreRows,
        totalMembersPages,
        totalMembersCount,
      };
    }
    case 'qa_reports/CLICKED_TEAM_MEMBER_REPORT_TABLE_HEADER': {
      const { sortBy } = action;
      const { teamMemberScoreRowsSortBy } = state;
      let { teamMemberScoreRowsSortDirection } = state;
      if (sortBy === teamMemberScoreRowsSortBy) {
        teamMemberScoreRowsSortDirection =
          teamMemberScoreRowsSortDirection === 'ascending' ? 'descending' : 'ascending';
      } else {
        teamMemberScoreRowsSortDirection = 'ascending';
      }
      return {
        ...state,
        teamMemberScoreRowsSortBy: sortBy,
        teamMemberScoreRowsSortDirection,
      };
    }
    default: {
      return state;
    }
  }
}

export const loadTeamMembersReportData =
  (
    history,
    { customProperties, snapshotFilters = {}, interactionSnapshotFiltersEnabled = false } = {}
  ) =>
  async (dispatch, getState) => {
    const { teamMemberReportState } = getState();
    const {
      startDate,
      endDate,
      teamIds,
      groupIds,
      reportingGroupIds,
      employeeIds,
      reviewerIds,
      autofailed,
      languages,
      channelEnumIds,
      propertyIds,
      page,
    } = getSearchFilter(history);
    const { teamMemberScoreRowsSortBy, teamMemberScoreRowsSortDirection } = teamMemberReportState;
    const queryParams = {
      completed_from: startDate,
      completed_to: endDate,
      by_reviewer_id: reviewerIds,
      by_employee_id: employeeIds,
      for_teams: teamIds,
      for_groups: groupIds,
      for_reporting_groups: reportingGroupIds,
      ...(!interactionSnapshotFiltersEnabled && { by_language: languages }),
      by_channel_enum_id: channelEnumIds,
      by_property_id: propertyIds,
      autofailed,
      ...(page && { members_page: page }),
      ...(customProperties ? { custom_properties: customProperties } : {}),
      ...snapshotFilters,
    };
    if (teamMemberScoreRowsSortBy) {
      queryParams.order_by = teamMemberScoreRowsSortBy;
      queryParams.order_direction =
        teamMemberScoreRowsSortDirection === 'descending' ? 'desc' : 'asc';
    }
    const response = await server.get('/api/v1/qa_reporting/team_members', queryParams);
    const scorecards = [];
    const scorecardsByScorecardId = {};
    response.scorecards.forEach(sc => {
      const scorecard = {
        scorecardId: sc.id,
        scorecardName: sc.name,
        hasSections: sc.has_sections,
      };
      scorecards.push(scorecard);
      scorecardsByScorecardId[scorecard.scorecardId] = scorecard;
    });
    const teamMemberScoreRows = response.team_members.map(employee => {
      const scoresByScorecardId = {};
      Object.entries(employee.scorecards).forEach(([id, details]) => {
        scoresByScorecardId[id] = {
          scoresAverage: details.scores_average,
          scoresSum: details.scores_sum,
          scoresCount: details.scores_count,
          previousScoresAverage: details.previous_scores_average,
          previousScoresSum: details.previous_scores_sum,
          previousScoreCount: details.previous_scores_count,
        };
      });
      return {
        employeeId: employee.id,
        employeeName: employee.name,
        employeeImage: employee.image,
        reviewsScored: employee.scored,
        reviewsUnscored: employee.unscored,
        scoresByScorecardId,
      };
    });
    dispatch({
      type: 'qa_reports/RECEIVED_TEAM_MEMBERS_DATA',
      scorecards,
      scorecardsByScorecardId,
      teamMemberScoreRows,
      totalMembersPages: response.total_pages,
      totalMembersCount: response.total_members,
    });
  };

export const clickTeamMembersReportTableHeader =
  ({ history, sortBy, metadataFilters = {} }) =>
  dispatch => {
    dispatch({
      type: 'qa_reports/CLICKED_TEAM_MEMBER_REPORT_TABLE_HEADER',
      sortBy,
    });
    dispatch(loadTeamMembersReportData(history, metadataFilters));
  };
